import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { addMaintenanceServiceImage } from '../../api/maintenance-service.ts';
import { AddMaintenanceServiceImageRequest } from '../../api/requests/maintenance-service-request.ts';

export default function useAddMaintenanceServiceImage(): UseMutationResult<
  Awaited<ReturnType<typeof addMaintenanceServiceImage>>,
  Error,
  AddMaintenanceServiceImageRequest
> {
  return useMutation({
    mutationFn: addMaintenanceServiceImage,
  });
}
